import { departmentService } from "../../../../Api/Services/DepartmentService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";
import {
  IDepartmentTaskListServiceResponse,
  IFetchDepartmentCategoryListPaylaod,
} from "../../types";

export const fetchDepartmentCategoryOptions = createServiceAsyncThunk<
  IDepartmentTaskListServiceResponse,
  IFetchDepartmentCategoryListPaylaod
>(
  ACTION_NAMES.FETCH_DEPARTMENT_WISE_TASK_OPTIONS,
  ({
    page,
    size,
    departmentId,
    nodeLevel,
  }: IFetchDepartmentCategoryListPaylaod) =>
    departmentService.getDepartmentsWiseCategoryList({
      page,
      size,
      department_id: departmentId,
      node_level: nodeLevel || undefined,
    }),
  ERROR_MESSAGES.DEPARTMENT_WISE_TASKS_LIST_FETCH_FAILURE
);

const departmentCategoryOptionsSlice = createGenericSlice<
  IDepartmentTaskListServiceResponse,
  IFetchDepartmentCategoryListPaylaod
>(SLICE_NAMES.DEPARTMENT_CATEGORY_OPTIONS, fetchDepartmentCategoryOptions);

export const {
  clearError: clearDepartmentCategoryOptionsError,
  clearSuccessMessage: clearDepartmentCategoryOptionsSucess,
} = departmentCategoryOptionsSlice.actions;

export default departmentCategoryOptionsSlice.reducer;
